import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { AuditActionsPage } from '@/features/security/audit-actions/audit-actions-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Journal d'audit des ACTIONS (R2.4) — `GET /audit/actions`. Les connexions restent sur `/$tenant/audit`. */
export const Route = createFileRoute('/$tenant/audit-trail')({ component: AuditTrailRoute });

function AuditTrailRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="auditTrail"
      crumbs={[{ label: t('security.auditActions.title') }]}
    >
      <AuditActionsPage tenantId={tenant} />
    </ConsoleShell>
  );
}
